import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { ConfirmationModal } from '@components';
import { FC } from 'react';
import { useReportFoldersPageTable } from '@views/pages/Reporting/ReportFolders/hooks';
import { ReportFoldersDataGrid } from '@views/pages/Reporting/ReportFolders/components/ReportFoldersDataGrid.tsx';
import { Folder } from '@mui/icons-material';

export interface ReportFoldersPageTableProps {
  query:
    | 'all'
    | 'favorites_only'
    | 'recently_viewed'
    | 'created_by_me'
    | 'recently_deleted';
}

export const ReportFoldersPageTable: FC<ReportFoldersPageTableProps> = ({
  query,
}) => {
  const {
    filters,
    entries,
    handleFilterChange,
    totalCount,
    loading,
    handleDeleteReportFolder,
    deleteReportFolderIsLoading,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    handleOpenDeleteModal,
    handleMakeReportFolderFavorite,
    makeReportFolderFavoriteIsPending,
    reportIdToFavorite,
    isInitialFilters,
  } = useReportFoldersPageTable({ query });

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {isInitialFilters && entries.length === 0 && !loading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Folder sx={{ width: 56, height: 56, mb: 2 }} color='primary' />
          <Typography variant='h6'>
            {t('reporting.folders.table.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {t('reporting.folders.table.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <ReportFoldersDataGrid
          rows={entries}
          filters={filters}
          setFilters={handleFilterChange}
          totalCount={totalCount}
          loading={loading}
          handleOpenDeleteModal={handleOpenDeleteModal}
          handleMakeReportFolderFavorite={handleMakeReportFolderFavorite}
          makeReportFolderFavoriteIsPending={makeReportFolderFavoriteIsPending}
          reportIdToFavorite={reportIdToFavorite}
        />
      )}
      <ConfirmationModal
        title={t('reporting.folders.deleteModal.title')}
        message={t('reporting.folders.deleteModal.message')}
        onConfirm={handleDeleteReportFolder}
        onClose={handleCloseDeleteModal}
        isOpen={isDeleteModalOpen}
        isLoading={deleteReportFolderIsLoading}
        confirmText={t('general.delete')}
      />
    </Box>
  );
};
